<template>
    <div>
        <div class="sau-bx" v-if="Object.keys(invoices).length > 0">
            <div class="sau-preview-bx">
                <table class="sau-bx-table">
                    <tbody>
                        <tr v-for="invoice in invoices" :key="invoice.invoice_no">
                            <td width="40"><span class="sau-dot xs" :title="ucFirst(invoice.status)" :class="getStatus(invoice.status)"></span></td>
                            <td width="40"><i class="fal fa-file-invoice"></i></td>
                            <td><a :href="`/billing/invoices/${invoice.invoice_no}`" class="sau-linx-hover gray">Invoice No: {{invoice.invoice_no}}</a></td>
                            <td align="right">{{ invoice.total | currency }}</td>
                            <td class="text-muted sau-font xs" align="right">{{invoice.status_text}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div v-else>
            <sau-apiro-response type="message">
                <template slot="message">Looks like you don't have any invoices</template>
                <template slot="details">
                    <p>Your latest invoices will appear here when they are available.</p>
                </template>
            </sau-apiro-response>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return{
            currentDate: moment(new Date).format('YYYY-MM-DD'),
            mappedInvoices: [],
        }
    },
    props:['invoices'],
    methods: {
        getStatus(status) {
            switch(status.toLowerCase()) {
                case 'paid' :
                    return 'success';
                        break;
                case 'unpaid' :
                    return 'unpaid';
                        break;
                case 'cancelled' :
                    return 'refunded';
                        break;
                case 'refunded' :
                    return 'refunded'
                        break;
                case 'overdue' :
                    return 'overdue'
                        break;
                default :
                    console.log('Unknown Status', status);
                    return 'warning';
                        break;
            }
        },
        ucFirst(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    },
    mounted() {
        this.mappedInvoices = this.invoices.map(function(invoice) {
            (invoice.status === 'unpaid' && moment(this.currentDate).isAfter(invoice.duedate)) ? invoice.status = 'overdue' : '';
            return invoice;
        }, this);
    }
}
</script>

<style>
.sau-dot.refunded {
    background-color: #cccccc;
}
.sau-dot.warning {
    background-color: #ffc107;
}
.sau-dot.overdue {
    background-color: #d8534f;
}
.sau-dot.unpaid {
    background-color: #0769ba;
}
</style>
